// frontend/src/components/LogoutRequiredModal.js
// Modal que pide al admin cerrar sesión antes de comprar/cambiar plan

import React from 'react';
import { FaExclamationTriangle, FaSignOutAlt, FaTimes } from 'react-icons/fa';
import './LogoutRequiredModal.css';

const LogoutRequiredModal = ({ show, onClose, onConfirmLogout }) => {
  if (!show) return null;

  return (
    <div className="urbanq-logout-modal-overlay" onClick={onClose}>
      <div className="urbanq-logout-modal" onClick={(e) => e.stopPropagation()}>
        <button className="urbanq-logout-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="urbanq-logout-modal-icon">
          <FaExclamationTriangle />
        </div>

        <h2 className="urbanq-logout-modal-title">
          Nuevo Inicio de Sesión Requerido
        </h2>

        <p className="urbanq-logout-modal-message">
          Para adquirir o cambiar tu plan de suscripción, es necesario cerrar tu sesión actual.
          Esto garantiza un proceso de compra seguro.
        </p>

        <p className="urbanq-logout-modal-subtext">
          Serás redirigido a la página de planes después de cerrar sesión.
        </p>

        <div className="urbanq-logout-modal-actions">
          <button
            className="urbanq-logout-modal-btn-primary"
            onClick={onConfirmLogout}
          >
            <FaSignOutAlt />
            <span>Cerrar Sesión y Continuar</span>
          </button>

          <button
            className="urbanq-logout-modal-btn-secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutRequiredModal;
